module.exports = __webpack_public_path__ + "static/img/menage5.cdbdd7b0.png";